import { useRouter } from "next/router";
import { type ReactNode, memo } from "react";
import { TutorialMemo } from "src/component/element/Tutorial/Tutorial";
import {
  badgeImages,
  closetImages,
  clubroomImages,
  fumufumuImages,
  loginImages,
  mapImages,
  memberlistImages,
  missionImages,
  mypageImages,
  rankingImages,
  sessionImages,
  shopImages,
  statusImages,
  styleImages,
} from "src/component/element/Tutorial/TutorialImageModel";
import { useGetTutorialQuery } from "src/service/TutorialApi";

const TutorialView = ({ children }: { children: ReactNode }): any => {
  const router = useRouter();
  const { data: tutorialData } = useGetTutorialQuery();

  switch (router.pathname) {
    case "/mypage":
      if (tutorialData?.myPage == false) {
        return (
          <>
            {children}
            <TutorialMemo image={mypageImages} title={"マイページ"} />
            <TutorialMemo
              image={loginImages}
              title={"ようこそTANQ BASEへ！"}
            />
          </>
        );
      } else {
        return children;
      }
    case "/session":
      if (tutorialData?.session == false) {
        return (
          <>
            {children}
            <TutorialMemo image={sessionImages} title={"セッション"} />
          </>
        );
      } else {
        return children;
      }
    case "/fumufumu/[value]":
      if (tutorialData?.fumufumu == false) {
        return (
          <>
            {children}
            <TutorialMemo image={fumufumuImages} title={"フムフム"} />
          </>
        );
      } else {
        return children;
      }
    case "/closet":
      if (tutorialData?.closet == false) {
        return (
          <>
            {children}
            <TutorialMemo image={closetImages} title={"クローゼット"} />
          </>
        );
      } else {
        return children;
      }
    case "/clubroom":
      if (tutorialData?.clubroom == false) {
        return (
          <>
            {children}
            <TutorialMemo image={clubroomImages} title={"部室"} />
          </>
        );
      } else {
        return children;
      }
    case "/map":
      if (tutorialData?.map == false) {
        return (
          <>
            {children}
            <TutorialMemo image={mapImages} title={"マップ"} />
          </>
        );
      } else {
        return children;
      }
    case "/member/[value]":
      if (tutorialData?.member == false) {
        return (
          <>
            {children}
            <TutorialMemo image={memberlistImages} title={"メンバー 一覧"} />
          </>
        );
      } else {
        return children;
      }
    case "/ranking/[value]":
      if (tutorialData?.ranking == false) {
        return (
          <>
            {children}
            <TutorialMemo image={rankingImages} title={"ランキング"} />
          </>
        );
      } else {
        return children;
      }
    case "/status":
      if (tutorialData?.status == false) {
        return (
          <>
            {children}
            <TutorialMemo image={statusImages} title={"ステータス"} />
          </>
        );
      } else {
        return children;
      }
    case "/mission":
      if (tutorialData?.mission == false) {
        return (
          <>
            {children}
            <TutorialMemo image={missionImages} title={"ミッション"} />
          </>
        );
      } else {
        return children;
      }
    case "/badge":
      if (tutorialData?.badge == false) {
        return (
          <>
            {children}
            <TutorialMemo image={badgeImages} title={"バッジ"} />
          </>
        );
      } else {
        return children;
      }
    case "/shop":
      if (tutorialData?.shop == false) {
        return (
          <>
            {children}
            <TutorialMemo image={shopImages} title={"ショップ"} />
          </>
        );
      } else {
        return children;
      }
    case "/style":
      if (tutorialData?.style == false) {
        return (
          <>
            {children}
            <TutorialMemo image={styleImages} title={"スタイル"} />
          </>
        );
      } else {
        return children;
      }
    default:
      return children;
  }
};

export const TutorialViewMemo = memo(TutorialView);
